import "./../css/style.scss";

import $ from 'jquery';

$(document).ready(function () {

    $.ajaxSetup({
        // Disable caching of AJAX responses
        cache: false
    });

    //Menu
    var lastScrollTop = 0;
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            //down
            $('.header_wrapp').removeClass("bottom-menu--sticky");
        } else if (st == 0) {
            $('.header_wrapp').removeClass("bottom-menu--sticky");
        } else if (st == lastScrollTop) {
            $('.header_wrapp').removeClass("bottom-menu--sticky");
        } else {
            //up
            $('.header_wrapp').addClass("bottom-menu--sticky");
        }
        lastScrollTop = st;
    });


    if ($('.ow-novice-slider').length) {
        $('.ow-novice-slider').slick({
            centerMode: true,
            // centerPadding: '30%',
            // centerPadding: '600px',
            slidesToShow: 5,
            // prevArrow: $('.white-prev'),
            // nextArrow: $('.white-next'),
            responsive: [
                {
                    breakpoint: 2365,
                    settings: {
                        centerPadding: '0%',
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1920,
                    settings: {
                        centerPadding: '30%',
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1201,
                    settings: {
                        centerPadding: '20%',
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: false,
                        centerPadding: '40px',
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        dots: true,
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
    if ($('.certifikati_block').length) {
        $('.certifikati_block .flex').slick({
            mobileFirst: true,
            slidesToShow: 3,
            dots: true,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 767,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
                {
                    breakpoint: 989,
                    settings: "unslick"
                }
            ]
        });
    }
    if ($('.banner-slider').length) {
        $('.banner-slider').slick({
            slidesToShow: 1,
            dots: true,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: false,
                    }
                },
            ]
        });
    }


    // if ($('.faq_block').length) {
    $('.acc_content').css("display", "none");

    $(document).on('click', '.acc_toggle', function () {
        if ($(this).hasClass("active")) {
            $(".acc_toggle").removeClass("active");
            $(this).next().slideUp().removeClass("active");
        } else {
            $(".acc_toggle").removeClass("active");
            $(this).addClass("active");
            $(this).next().slideToggle().addClass("active");
            //Hide the other panels
            $(".acc_content").not($(this).next()).slideUp().removeClass("active");
        }
    });
    // }


    if ($('#vsi_faq').length) {
        $('.faq_term').on('click', function () {
            $('.faq_term').removeClass('text--green');
            $(this).addClass('text--green');
            $('.faqs-single-cat').hide();
            var id = '#' + $(this).data('id');
            $(id).show();
        })
    }
    $(".faq_term[prikazi='prikazi-to']").trigger('click');

    if ($('.block_kontakti').length) {
        $('.kontakt_button').on('click', function () {
            $('.kontakt_button').removeClass('bg_green').addClass('bg_black');
            $(this).addClass('bg_green');
            $('.block_poslovalnice').hide();
            var id = '#' + $(this).data('id');
            $(id).show();
        })
        $(".kontakt_button[data-id='kontakti_poslovalnice']").trigger('click');
    }

    /*Responsive*/

    if ($(window).width() < 989) {
        $('#search').on('click', '.search-submit', function (event) {
            if ($('.search-field').hasClass('visible')) {
                return true;
            }
            event.preventDefault();
            $('.search-field').toggleClass('visible');

        })
    }

    if ($('.block_poslovalnice').length) {
        $('.block_poslovalnice').closest('.ow_container_section').addClass("slider_on_mobile");
        // $('.block_poslovalnice').slick({
        $('#kontakti_poslovalnice').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }
    if ($('.ponudba_block ').length) {
        $('.ponudba_block ').closest('.ow_container_section').addClass("slider_on_mobile");
        $('.ponudba_block ').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }
    if ($('.samo_posti').length) {
        $('.samo_posti').closest('.ow_container_section').addClass("slider_on_mobile");
        $('.samo_posti').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('.single-produkti').length) {
        $('#sorodni-produkti').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }

    $('.single_term').on("click", function () {
        $(this).toggleClass('checked');
    });


    if ($('.block_kontakti').length) {
        $('.filter').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('.post-type-archive-blog,.tax-blog_kategorije ').length) {
        $('.slider_on_smaller').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 989,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($(window).width() < 989) {
        $('.filter-produktov-inner').css("display", "none");

        $(document).on('click', '.filter_label', function () {
            if ($(this).hasClass("active")) {
                $(".filter_label").removeClass("active");
                $(this).next().slideUp().removeClass("active");
            } else {
                $(".filter_label").removeClass("active");
                $(this).addClass("active");
                $(this).next().slideToggle().addClass("active");
                //Hide the other panels
                $(".filter-produktov-inner").not($(this).next()).slideUp().removeClass("active");
            }
        });
    } else {
        $('.filter_label').css("display", "none");
    }

    if ($(window).width() < 989) {
        $('.menu-item-has-children').on('click', function () {
            $(this > '.sub-menu').toggleClass('hide-this');
        })
    }

    if ($('#filter-produktov-outer').length) {

        $('.inner_terms_wrap').css("display", "none");

        $(document).on('click', '.single_kategorija_label', function () {

            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(".inner_terms_wrap").removeClass("active");
                $(this).next().slideUp().removeClass("active");
            } else {
                /*
                                $(".single_kategorija_label").removeClass("active");
                */
                $(this).addClass("active");
                $(this).next().slideToggle().addClass("active");
                //Hide the other panels
                /*
                                $(".inner_terms_wrap").not($(this).next()).slideUp().removeClass("active");
                */
            }
        });


        $('.child_wrap').css("display", "none");


        $(document).on('click', '.parent_term_wrapper', function () {

            $(this).find('.parent_term div').toggleClass("active");
            $(this).find('.child_wrap').toggleClass("active");

            if ($(this).find('.parent_term div').hasClass("active")) {
                $(this).parent().find('.child_wrap').slideDown();
                $(this).parent().find('.grandchild_wrap').slideDown();
                $(this).find(".dropdown-icon").addClass("active");
                $(this).parent().find(".child_term").addClass("active");
                $(this).parent().find(".dropdown-icon-child").addClass("active");
            } else {
                $(this).parent().find('.child_wrap').slideUp();
                $(this).parent().find('.grandchild_wrap').slideUp();
                $(this).parent().find(".child_term").remove("active");
                $(this).find(".dropdown-icon").removeClass("active");
                $(this).parent().find(".dropdown-icon-child").removeClass("active");
            }
        });

        $(document).on('click', '.parent_term', function (event) {
            event.stopPropagation();
        });

        //filter tags

        $(document).on('click', '#filter-produktov-outer input', function () {

            $(this).toggleClass('filter-tag-active');

            if ($(this).parent().parent().prev('.child_input_label_wrap').length !== 0) {
                if ($(this).hasClass('filter-tag-active')) {
                    $(".filter-tags").append("<div class='tag-container tag" + $(this).val() + "' for='" + $(this).val() + "'>" + $(this).parent().parent().prev('.child_input_label_wrap').find('.child_term span').text() + ": " + $(this).next('span').text() + "<div class='close-filter-tag'></div>" + "<div>");
                } else {
                    $(".filter-tags .tag" + $(this).val() + "").remove();
                }
            } else if ($(this).parent().parent().parent().prev('.parent_term_wrapper').length !== 0) {

                if ($(this).hasClass('filter-tag-active')) {
                    $(".filter-tags").append("<div class='tag-container tag" + $(this).val() + "' for='" + $(this).val() + "'>" + $(this).parent().parent().parent().prev('.parent_term_wrapper').find('.parent_term div').text() + ": " + $(this).next('span').text() + "<div class='close-filter-tag'></div>" + "</div>");
                } else {
                    $(".filter-tags .tag" + $(this).val() + "").remove();
                }
            } else if ($(this).parent().parent().find('.parent_term_wrapper').length !== 0) {
                if ($(this).hasClass('filter-tag-active')) {
                    $(".filter-tags").append("<div class='tag-container tag" + $(this).val() + "' for='" + $(this).val() + "'>" + $(this).next('.parent_term').find('div').text() + "<div class='close-filter-tag'></div>" + "</div></div>");
                } else {
                    $(".filter-tags .tag" + $(this).val() + "").remove();
                }
            } else {
                if ($(this).hasClass('filter-tag-active')) {
                    $(".filter-tags").append("<div class='tag-container tag" + $(this).val() + "' for='" + $(this).val() + "'>" + $(this).siblings('span').text() + "<div class='close-filter-tag'></div>" + "</div></div>");
                } else {
                    $(".filter-tags .tag" + $(this).val() + "").remove();
                }
            }
        });

        $('.grandchild_wrap').css("display", "none");


        if ($('#filter-produktov-outer').length) {

            $(".child_term span").each(function () {
                if ($(this).text() === 'Oplemenitene iverne plošče') {
                    $("[data-tax='klasifikacija_artikla'] .single_kategorija_label").click();

                    $(this).parent().parent().parent().slideDown();
                    $(this).parent().parent().parent().parent().find('.dropdown-icon').addClass('active');
                    $(this).parent().parent().parent().find('.grandchild_wrap').slideDown();
                    $(this).parent().parent().parent().find(".child_term").addClass("active");
                    $(this).parent().parent().parent().find(".dropdown-icon-child").addClass("active");

                    let array = $(this).parent().parent().parent().find('.grandchild_wrap');

                    array.each(function (index) {
                        $(array[index]).show();
                    });
                    $(this).prev('input').click();

                }
            });

        }


        //close fiter tag

        $(document).on('click', '.close-filter-tag', function () {
            $(this).parent().remove();

            let value = $(this).parent().attr('for');

            $("#filter-produktov-outer input").each(function () {

                if (value === $(this).attr('value')) {
                    $(this).click();
                }
            });

        });


        //toggle dropdown with icon

        $(document).on('click', '.dropdown-icon-child', function () {

            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {
                $(this).parent().next('.grandchild_wrap').addClass("active");
                $(this).parent().next('.grandchild_wrap').slideDown();
            } else {
                $(this).parent().next('.grandchild_wrap').removeClass("active");
                $(this).parent().next('.grandchild_wrap').slideUp();
            }

        });


    }

    if ($(window).width() < 989) {
        if (window.location.hash == "#sekcija-obrazec") {
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top - 120
            }, 500);
        }
    }

});